import type { ReactNode } from "react";
import type { StyleProp, ViewStyle } from "react-native";

/** App-web: the browser moves the page for its keyboard; the content is
 *  passed through as it is (the native one pads it by the keyboard). */
export function StableKeyboardInset({
  children,
}: {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  return <>{children}</>;
}
